import { ListCollection, Select, Text } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { useIntl } from 'react-intl';

import { Option } from './Select';

type Props<T extends Option> = {
  collection: ListCollection<T>;
  noOptionMessage?: string;
  textStyle: 'sm' | 'md' | 'lg';
  formatLabel?: (value: T) => ReactElement;
};

export default function DefaultList<T extends Option>({
  collection,
  noOptionMessage,
  textStyle,
  formatLabel,
}: Readonly<Props<T>>) {
  const { formatMessage } = useIntl();
  if (collection.size === 0) {
    return (
      <Text padding={2} width="100%" textAlign="center">
        {formatMessage({ id: noOptionMessage ?? 'components.select.noOption' })}
      </Text>
    );
  }

  return collection.items.map((item) => (
    <Select.Item item={item} key={item.value}>
      {formatLabel ? formatLabel(item) : <Text textStyle={textStyle}>{item.label}</Text>}
    </Select.Item>
  ));
}
